'use strict';

/**
 * This directive exists as an alternative to ng-mouseover,
 * as a bug exists in the header whereby the use of ng-mouseover
 * is changing the url.
 */

module.exports = function(
) {
    return {
        link: function(scope, element, attrs) {
            element.on('mouseover', function(event) {
                scope.$eval(attrs.mouseover);
                return false;
            });
        }
    };
};
